module.exports = __webpack_public_path__ + "static/media/history.a9fca009.svg";